// extracted by mini-css-extract-plugin
export default {"btn":"Settings_btn__gAllg","container":"Settings_container__HvzOG","name":"Settings_name__XS5Ij","userBtn":"Settings_userBtn__mmvdf","active":"Settings_active__Jv2bG"};